import { Component, OnInit, ViewChild } from '@angular/core';
import { BrandStatsService } from "../../services/stats/brand-stats.service";
import { ConfirmationService } from "primeng/api";
import { SharedService } from "../../shared/services/shared.service";
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { BrandService } from '../../services/config/brand.service';
import { IBrand } from '../../shared/interfaces/brand';
import { BrandAdminHeaderComponent } from '../../shared/components/brand-admin-header/brand-admin-header.component';
import { IClickthroughStats } from 'src/app/interfaces/artifacts/click-thru-stats';

@Component({
  selector: 'app-clickthrough-stats',
  standalone: false,
  templateUrl: './clickthrough-stats.component.html',
  styleUrls: ['./clickthrough-stats.component.css']
})
export class ClickthroughStatsComponent implements OnInit {

  @ViewChild(BrandAdminHeaderComponent, {static : true}) child! : BrandAdminHeaderComponent;  

  titleMessage = "Clickthrough Statistics";
  isBrandSelectionButtonShown: boolean = true;
  openBrandSelectionDialog: boolean = false;
  isDetailsShown = false;
  currentBrand!: IBrand;
  defaultDate: any;
  brandName!: string;
  brandList = [];

  envRegions = [];
  brands = [];
  baseUrl: string = '';
  selectedBrand: string ='';
  selectedBrandName!: string;
  selectedDateFrom!: string;
  selectedDateTo!: string;

  clickthroughStatsCols!: any[];
  clickthroughStats: any[] = [];
  clickthroughStatsChart: any;
  optionsClickthroughs: any;

  aggregationTypes: any[] = [];
  aggregationType: string = '';

  totalAppleWalletCnt: number = 0;
  totalGoogleWalletCnt: number = 0;
  totalSamsungWalletCnt: number = 0;

  isSpinnerHidden: boolean = true;
  isSamsungPlatformEnabled: boolean = false;

  tabIndex: string = 'Bar Chart View';
 
  constructor(    
    private tokenStorageService: TokenStorageService,    
    private brandService: BrandService,
    private brandStatsService: BrandStatsService, 
    private confirmationService: ConfirmationService,
    private sharedService: SharedService) { 
  }

  ngOnInit() {
    this.aggregationTypes = [
      {label: 'Link Category', value: 'category'},
      {label: 'Category Group', value: 'category_group'},
      {label: 'Link Text', value: 'link_text'}
    ];
    this.aggregationType = 'category';
      // Define the columns for ClickthroughStats grid
      this.setClickthroughStatsCols();
      this.optionsClickthroughs = this.sharedService.options('Clickthrough Counts by Device Platform');
      this.selectedDateFrom = this.sharedService.getOneWeekAgoDate();
      this.selectedDateTo = this.sharedService.getCurrentDate();

      // Figure out whether the user has just one granted brand - in this case we can eliminate brand selection altogether
      let assignedBrand = this.tokenStorageService.getCurrentUserAssignedBrand();
      if (assignedBrand) {
        this.setSingleBrand(assignedBrand);
      } else {
        this.isBrandSelectionButtonShown = true;
        this.currentBrand = this.sharedService.getCurrentBrand();
        if (this.currentBrand != null && this.currentBrand.brandCode) {
          this.child.makeTitleMessage(this.currentBrand, this.titleMessage);
          this.selectedBrand = this.currentBrand.brandCode || '';
          this.baseUrl = this.currentBrand.baseUrl || '';
          this.isSamsungPlatformEnabled = this.currentBrand.isSamsungPlatformEnabled || false;
          this.setClickthroughStatsCols();
          this.openBrandSelectionDialog = false;
        } else {
          this.openBrandSelectionDialog = true;
        }  
      }
  }

  setClickthroughStatsCols() {
    if (this.isSamsungPlatformEnabled) {
      this.clickthroughStatsCols = [
        { field: 'linkName', header: 'Link Type', width:'25%', display: 'table-cell' },
        { field: 'appleWalletCnt', header: 'Apple Wallet Cnt', width:'25%', display: 'table-cell' },
        { field: 'googleWalletCnt', header: 'Google Wallet Cnt', width:'25%', display: 'table-cell' },
        { field: 'samsungWalletCnt', header: 'Samsung Wallet Cnt', width:'25%', display: 'table-cell' }
      ]; 
    } else {
      this.clickthroughStatsCols = [
        { field: 'linkName', header: 'Link Type', width:'40%', display: 'table-cell' },
        { field: 'appleWalletCnt', header: 'Apple Wallet Cnt', width:'30%', display: 'table-cell' },
        { field: 'googleWalletCnt', header: 'Google Wallet Cnt', width:'30%', display: 'table-cell' }
      ]; 
    }
  }

  // Set single brand as the default when the user has just one brand granted
  setSingleBrand(brandCode: string) {
    this.isBrandSelectionButtonShown = false;
    this.isSpinnerHidden = false;
    this.brandService.getBrandWithRegion(brandCode)
    .subscribe({
      next: (response) => {
        this.currentBrand = response;
        this.child.makeTitleMessage(this.currentBrand, this.titleMessage);
        this.baseUrl = response.baseUrl || '';
        this.selectedBrand = response.brandCode || '';
        this.setClickthroughStatsCols();
        this.isSpinnerHidden = true;
      },
      error: (error) => {
      },
      complete: () => {
      }
    });
  }

  // When the user opens up the dialog to select a brand 
  onChooseBrandClick(event: any) {
    this.openBrandSelectionDialog = true;
  }

  onClearClick(event: any) {
    // this.baseUrl = null;
    // this.selectedBrand = null;
    this.selectedDateFrom = '';
    this.selectedDateTo = '';
  }

  chooseBrand(item: IBrand) {
    this.openBrandSelectionDialog = false;
    if (item != null) {
      this.currentBrand = item;
      this.sharedService.setCurrentBrand(item);
      this.selectedBrand = item.brandCode || '';
      this.selectedBrandName = " ( " + item.brandName + " )";
      this.baseUrl = item.baseUrl || '';
      this.isSamsungPlatformEnabled = this.currentBrand.isSamsungPlatformEnabled || false;
      this.clickthroughStats = [];
      this.clickthroughStatsChart = [];
      this.totalAppleWalletCnt = 0;
      this.totalGoogleWalletCnt = 0;
      this.totalSamsungWalletCnt = 0;
      this.setClickthroughStatsCols();
      this.child.makeTitleMessage(this.currentBrand, this.titleMessage);
    }
  }

  // Process the Search request
  onSearchClick(event: any) {
    this.totalAppleWalletCnt = 0;
    this.totalGoogleWalletCnt = 0;
    this.totalSamsungWalletCnt = 0;
    if (!(this.aggregationType && this.selectedBrand && this.selectedDateFrom && this.selectedDateTo)) {
      this.confirmationService.confirm({
        message: 'Make sure to select the aggregation type, a brand and the date interval in the selection criteria to retireve database records.',
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Ok",
        rejectVisible: false,
        acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
        accept: () => {
              return;
            }
      });          
      return;
    }
    this.isSpinnerHidden = false;
    this.brandStatsService.getClickthroughStats(
           this.selectedBrand, this.selectedDateFrom, this.selectedDateTo, this.aggregationType)
          .subscribe({
            next: (response) => {
              let result: IClickthroughStats[] = JSON.parse( response.responseData);
              this.isSpinnerHidden = true;
              if (result.length == 0) {
                this.clickthroughStats = [];
                this.clickthroughStatsChart = {
                  labels: [],
                  datasets: []
                }
                this.confirmationService.confirm({
                  message: 'No records found for the specified selection criteria.',
                  header: 'Warning',
                  icon: 'pi pi-exclamation-triangle',
                  acceptLabel: "Ok",
                  rejectVisible: false,
                  acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
                  accept: () => {
                        return;
                      }
                });          
              }
              else {
                // Populate the grid
                result.forEach(element => {
                  this.totalAppleWalletCnt += Number(element.appleWalletCnt);
                  this.totalGoogleWalletCnt += Number(element.googleWalletCnt);
                  if (this.isSamsungPlatformEnabled) {
                    this.totalSamsungWalletCnt += Number(element.samsungWalletCnt);
                  }
                })
                this.clickthroughStats = result;
                // Populate the chart
                var labels = [];
                var appleWallet = [];
                var googleWallet = [];
                var samsungWallet = [];
                for(let i = 0; i < result.length; i++){
                  // var label = result[i].linkName;
                  // var index = labels.findIndex(element => element == label);
                  // if (index < 0) {
                  //   labels.push(label);
                  // }
                  const res = result[i];
                  if (res) {
                    var label = res.linkName;
                    var index = labels.findIndex(element => element == label);
                    if (index < 0) {
                      labels.push(label);
                    }
                  }
                }
                for(let i = 0; i < result.length; i++){
                  // var label = result[i].linkName;
                  // var index = labels.findIndex(element => element == label);
                  // if (index >= 0) {
                  //     appleWallet[index] = result[i].appleWalletCnt;
                  //     googlePay[index] = result[i].googlePayCnt;
                  //     samsungWallet[index] = result[i].samsungWalletCnt;
                  // }
                  const res = result[i];
                  if (res) {
                    var label = res.linkName;
                    var index = labels.findIndex(element => element == label);
                    if (index >= 0) {
                        appleWallet[index] = res.appleWalletCnt;
                      googleWallet[index] = res.googleWalletCnt;
                        samsungWallet[index] = res.samsungWalletCnt;
                    }
                  }
                }
      
                this.clickthroughStatsChart = {
                  labels: labels,
                  datasets: [
                      {
                          label: 'Apple Wallet',
                          backgroundColor: 'blue',
                          borderColor: 'darkblue',
                          data: appleWallet
                      },
                      {
                        label: 'Google Wallet',
                        backgroundColor: 'green',
                        borderColor: 'darkgreen',
                        data: googleWallet
                      }
                    ]
                } 
                if (this.isSamsungPlatformEnabled) {
                  this.clickthroughStatsChart.datasets.push(
                    {
                      label: 'Samsung Wallet',
                      backgroundColor: 'red',
                      borderColor: 'darkred',
                      data: samsungWallet
                    }                  
                  );
                }
      
              }
      
            },
            error: (error) => {
            },
            complete: () => {
            }
          });
  }

}
